import React from "react";
import arrowImg from "../../../../assets/images/arrow.png";
import { fetchBindEquipment } from "../../../../api/business";
import { Form, Input, Modal, Select, message, Radio, Button } from "antd";
import { number } from "prop-types";
const formItemLayout = {
  labelCol: {
    xs: { span: 12 },
    sm: { span: 6 },
  },
  wrapperCol: {
    xs: { span: 36 },
    sm: { span: 18 },
  },
};
const { Option } = Select;
class EditEmployee extends React.Component {
  state = {
    bindInfo: {
      capsuleNo: "",
      type: "SHARE",
      shareRule: 10,
      amount: "",
    },
    confirm: false,
  };
  handleOk = (e) => {
    e.preventDefault();
    this.props.form.validateFieldsAndScroll(async (err, values) => {
      if (!err) {
        if (this.props.confirm) {
          this.props.handleCancel();
          this.props.getBusinessList();
          let tempObj = this.state.bindInfo;
          delete tempObj["capsuleNo"];
          fetchBindEquipment({
            ...tempObj,
            companyId: this.props.businessInfo.companyId,
          }).then((res) => {
            if (res.success) {
              this.setState({
                bindInfo: {
                  capsuleNo: "",
                  type: "SHARE",
                  shareRule: 10,
                  amount: "",
                },
              });
              message.success("绑定成功");
              this.props.getBusinessList();
            }
          });
        } else {
          this.props.setConfirm();
          // function returnFloat(value) {
          //   var value = Math.round(parseFloat(value) * 100) / 100;
          //   var xsd = value.toString().split(".");
          //   if (xsd.length == 1) {
          //     value = value.toString() + ".00";
          //     return value;
          //   }
          //   if (xsd.length > 1) {
          //     if (xsd[1].length < 2) {
          //       value = value.toString() + "0";
          //     }
          //     return value;
          //   }
          // }

          this.setState(
            {
              bindInfo: values,
            },
            () => {
              if (this.state.bindInfo.capsuleId) {
                this.props.equipmentList.forEach((item) => {
                  if (item.capsuleId === this.state.bindInfo.capsuleId) {
                    this.setState({
                      bindInfo: {
                        ...this.state.bindInfo,
                        capsuleNo: item.capsuleNo,
                      },
                    });
                  }
                });
              }
            }
          );
        }
      }
    });
  };
  renderOption = () => {
    let arr = [];
    if (this.props.type == "SHARE") {
      for (let i = 1; i < 101; i++) {
        arr.push(i);
      }
    } else if (this.props.type == "OFFLINE_SHARE") {
      for (let i = 0; i <= 100; i++) {
        arr.push(i);
      }
    }

    return arr.map((item) => (
      <Option key={item} value={item}>
        {item}
      </Option>
    ));
  };

  render() {
    const { getFieldDecorator } = this.props.form;
    const {
      visible,
      handleCancel,
      businessInfo,
      equipmentList,
      confirm,
      radioChange,
      setConfirmFalse,
      type,
    } = this.props;
    const { bindInfo } = this.state;

    return (
      <Modal
        destroyOnClose={true}
        title={!confirm ? "绑定设备" : "确认绑定信息"}
        visible={visible}
        width={700}
        onCancel={() => {
          handleCancel();
          this.setState({
            bindInfo: {
              capsuleNo: "",
              type: "SHARE",
              shareRule: 10,
              amount: "",
            },
          });
        }}
        footer={
          <React.Fragment>
            {!confirm ? (
              <React.Fragment>
                <Button
                  onClick={() => {
                    handleCancel();
                    this.setState({
                      bindInfo: {
                        capsuleNo: "",
                        type: "SHARE",
                        shareRule: 10,
                        amount: "",
                      },
                    });
                  }}
                >
                  取消
                </Button>
                <Button onClick={this.handleOk} type="primary">
                  确定
                </Button>
              </React.Fragment>
            ) : (
              <React.Fragment>
                <Button onClick={() => setConfirmFalse()}>上一步</Button>
                <Button onClick={this.handleOk} type="primary">
                  确定
                </Button>
              </React.Fragment>
            )}
          </React.Fragment>
        }
      >
        <Form onSubmit={this.handleOk} {...formItemLayout}>
          {!confirm ? (
            <React.Fragment>
              <Form.Item label="设备编号">
                {getFieldDecorator("capsuleId", {
                  initialValue: bindInfo.capsuleId,
                  rules: [{ required: true, message: "请选择设备编号" }],
                })(
                  <Select style={{ width: 300 }} placeholder="请选择设备编号">
                    {equipmentList.map((item) => (
                      <Option key={item.capsuleId} value={item.capsuleId}>
                        {item.capsuleNo}
                      </Option>
                    ))}
                  </Select>
                )}
              </Form.Item>
              {/* <div
                style={{ width: "100%", borderBottom: "1px dashed #ccc" }}
              ></div> */}
              {/* <Form.Item style={{ marginTop: 24 }} label="收款方式">
                {getFieldDecorator("type", {
                  initialValue: bindInfo.type,

                  rules: [{ required: true, message: "请选择收款方式" }],
                })(
                  <Radio.Group onChange={radioChange}>
                    <Radio value="SHARE">分账收款</Radio>
                    <Radio value="BUY">销售</Radio>
                    <Radio value="OFFLINE_SHARE">线下分账</Radio>
                  </Radio.Group>
                )}
              </Form.Item> */}

              {type === "SHARE" || type === "OFFLINE_SHARE" ? (
                <Form.Item label="分账规则">
                  平台占每笔订单收入的
                  {getFieldDecorator("shareRule", {
                    initialValue: bindInfo.shareRule,

                    rules: [{ required: true, message: "请选择分账" }],
                  })(
                    <Select style={{ width: 70, margin: "0 5px" }}>
                      {this.renderOption()}
                    </Select>
                  )}
                  %
                </Form.Item>
              ) : (
                <Form.Item label="购买金额">
                  {getFieldDecorator("amount", {
                    initialValue: bindInfo.amount,
                    rules: [
                      { required: true, message: "请输入设备金额" },
                      {
                        pattern: /^(\d+)(.\d{0,2})?$/,
                        message: "请输入最多保留两位小数的数字",
                      },
                    ],
                  })(
                    <Input
                      placeholder="请输入设备金额"
                      style={{ width: 250 }}
                      suffix="元"
                    ></Input>
                  )}
                </Form.Item>
              )}
            </React.Fragment>
          ) : (
            <React.Fragment>
              <div style={{ marginBottom: 5 }}>
                <div className="serialNumber">1</div>
                {businessInfo.companyName}
                <img src={arrowImg} style={{ marginBottom: 5 }}></img>
                <span style={{ marginRight: 5 }}>设备：</span>
                {bindInfo.capsuleNo}
              </div>
              <div style={{ marginBottom: 10 }}>
                <div className="serialNumber">2</div>
                {/* {bindInfo.type === "SHARE" || */}
                {/* // bindInfo.type === "OFFLINE_SHARE" ? ( */}
                <React.Fragment>
                  <span style={{ marginRight: 5 }}>分账规则：</span>
                  平台占每笔订单收入的<a>{bindInfo.shareRule}</a>%
                </React.Fragment>
                {/* // ) : (
                //   <React.Fragment>
                //     <span style={{ marginRight: 5 }}>购买金额：</span>
                //     <a>{bindInfo.amount}</a>元
                //   </React.Fragment>
                // )} */}
              </div>
            </React.Fragment>
          )}
        </Form>
      </Modal>
    );
  }
}

export default Form.create()(EditEmployee);
